<template>
  <div>
    <claim-life-cycle :query="query"></claim-life-cycle>
  </div>
</template>

<script>
import ClaimLifeCycle from './entry/ClaimLifeCycle'

export default {
  data() {
    return {
      steps: 1
    }
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ClaimLifeCycle
  }
}
</script>

<style lang="scss">
// Overwrite timeline content (default will hide content after steps passed)
.policyLifeCycle {
  &.v-stepper {
    box-shadow: none;
    .v-stepper__label {
      display: inline-block;
    }
    .v-stepper__content {
      display: block !important;
      padding: 0 16px 16px 16px;
      span {
        padding-left: 10px;
      }
      .v-stepper__wrapper {
        height: auto !important;
      }
    }
  }
}
</style>
